var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dvh-100"},[_c('router-view'),_c('span',{staticClass:"bomsu-commit"},[_vm._v(" "+_vm._s(_vm.versionCommit))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }